import { render } from "./IconGiven.vue?vue&type=template&id=6ee629bd"
import script from "./IconGiven.vue?vue&type=script&lang=js"
export * from "./IconGiven.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__